import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Modal, Row } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import {
  SuccessIconCircle,
  SuccessTitle,
  SuccessSubtitle,
  SuccessLocationText,
  EnterButton,
} from '../styles';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';

const WorkStationCheckinSuccessModal = ({ show, firstName, headquarterName, workStationName, onClose, onReset }) => {
  const { translate: t } = useDictionaryTranslation();

  return (
    <Modal open={show} footer={null} closable={false} maskClosable={false} centered width={360}>
      <div style={{ textAlign: 'center', padding: '16px 0' }}>
        <SuccessIconCircle>
          <CheckOutlined style={{ color: '#52c41a', fontSize: 28 }} />
        </SuccessIconCircle>
        <SuccessTitle>{t('checkinSuccessGreeting')}, {firstName}!</SuccessTitle>
        <SuccessSubtitle>{t('checkinSuccessSubtitle')}</SuccessSubtitle>
        <SuccessLocationText>{headquarterName} · {workStationName}</SuccessLocationText>
        <Row justify="center" style={{ marginTop: 24 }}>
          <Col xs={22}>
            <EnterButton block onClick={onClose} style={{ marginBottom: 4 }}>
              {t('continue')}
            </EnterButton>
            <Button type="link" block onClick={onReset}>
              {t('checkinRestart')}
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

WorkStationCheckinSuccessModal.propTypes = {
  show: PropTypes.bool,
  firstName: PropTypes.string,
  headquarterName: PropTypes.string,
  workStationName: PropTypes.string,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
};

export { WorkStationCheckinSuccessModal };
